import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { getAsync } from "../../../Common/Api/CommonGet";
import { IBlogList, IBlogListErrorResponse, IBlogListRequest } from "../../../Common/Api/BlogApi/Interfaces/Blog";
import { BLOG_FILTER_URL } from "../../../Common/Globals";

export const getBlogList = createAsyncThunk
<IBlogList, IBlogListRequest | undefined, {rejectValue: IBlogListErrorResponse}>(
    "blog-list/get", async (req, thunkAPI) => {
        const blogResponse = await getAsync({url: (req)?req.url:BLOG_FILTER_URL, cache: "default", credentials: "include"});
        
        if (blogResponse.responseStatus === 200) {
            return {
                ...blogResponse.responseJson
            } as IBlogList;
        }
        else {
            let err_msg = "";
            if (blogResponse.responseJson["detail"])
                err_msg = blogResponse.responseJson["detail"]
            else if (blogResponse.responseJson["message"])
                err_msg = blogResponse.responseJson["message"]
            let response = {
                error_description: err_msg,
            }
            return thunkAPI.rejectWithValue((response) as IBlogListErrorResponse)
        }
    }
)

export const getBlogListBuilder = (builder: ActionReducerMapBuilder<IBlogList>) => {
    builder.addCase(getBlogList.pending, (state) => {
        return {
            ...state,
            request_states: {
                ...state.request_states,
                get: {
                    ...state.request_states.get,
                    pending: true, fulfilled: false, rejected: false,
                }
            },
        }
    })
    builder.addCase(getBlogList.fulfilled, (state, action) => {
        return {
            ...state,
            ...action.payload,
            // append to the existing list to reduce network usage
            results: [ ...state.results, ...action.payload.results ],
            request_states: {
                ...state.request_states,
                get: {
                    ...state.request_states.get,
                    pending: false, fulfilled: true, rejected: false,
                }
            },
        };
    })
    builder.addCase(getBlogList.rejected, (state, action) => {
        return {
            ...state,
            request_states: {
                ...state.request_states,
                get: {
                    ...state.request_states.get,
                    pending: false, fulfilled: false, rejected: true,
                    error_description: action.payload?.error_description,
                }
            },
        };
    })
}